// PA Redux States
import {
  GET_PREMIUMS_ACCOUNTS,
  GET_PREMIUMS_ACCOUNTS_SUCCESS,
  GET_PREMIUMS_ACCOUNTS_FAIL,
  SET_SELECTED_PA,
} from "./actionTypes";

const INIT_STATE = {
  pas: [],
  loadingState: "NOT_LOADED",
  // NOT_LOADED -> Loading -> LOADED
  //                       \-> ERROR
  selectedPA: "",
  error: {
    message: "",
  },
};

const PAReducer = (state = INIT_STATE, action) => {
  let newState = state;
  switch (action.type) {
    case GET_PREMIUMS_ACCOUNTS:
      newState = { ...state, loadingState: "LOADING" };
      break;

    case GET_PREMIUMS_ACCOUNTS_SUCCESS:
      newState = { ...state, pas: action.payload, loadingState: "LOADED" };
      break;

    case GET_PREMIUMS_ACCOUNTS_FAIL:
      newState = {
        ...state,
        error: {
          message: action.payload,
        },
        loadingState: "ERROR",
      };
      break;

    case SET_SELECTED_PA:
      newState = {
        ...state,
        selectedPA: action.address,
      };
      break;

    default:
      break;
  }
  return newState;
};

export default PAReducer;
